<template>

  <div>
    <dialog-send-test-email ref="dialogSendTestEmail"></dialog-send-test-email>
    <dialog-view-integrations-instructions ref="dialogViewIntegrationsInstructions"></dialog-view-integrations-instructions>

    <div v-if="watch_twilio_tutorial" @click.self="watch_twilio_tutorial = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="bg-white rounded-lg mx-6" style="max-height: 95%;overflow-y: auto;">

        <div class="rg-modal-header">
          Twilio Setup Video Tutorial

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="watch_twilio_tutorial = false"><i class="fa fa-times"></i></a>
        </div>

        <div class="p-6" style="font-size: 12px;">

          <div class="flex flew-row flex-wrap">
            <div class="w-full sm:w-1/2 pr-10" style="font-size: 14px;">
              <strong style="font-size: 16px;">Step 1:</strong><br /> Create An Account - Confirm your account via email<br />
              Verify your account via phone number

              <br /><br />

              <strong style="font-size: 16px;">Step 2:</strong><br /> Tell Twilio about your intentions. What twill product are you here to use?<br />
              <strong style="color: gray;">SMS</strong>

              <br /><br />
              What do you plan to build with Twilio?<br />
              <strong style="color: gray;">Other</strong>

              <br /><br />

              How do you want to build with Twilio?<br />
              <strong style="color: gray;">With no code at all</strong>

              <br /><br />

              <strong style="font-size: 16px;">Step 3:</strong><br /> Copy & Paste API Key. Once inside your account copy and paste your API credentials into Local Lead Sniper.
              Copy both your:<br />
              <strong style="color: gray;">- Account SID</strong><br />
              <strong style="color: gray;">- Auth Token</strong>

              <br /><br />
              
              And add them to Local Lead Sniper.

              <br /><br />

              <strong style="font-size: 16px;">Step 4:</strong><br /> Add Credit Card On File & Add Funds. Go to billing then payment - and add $20 with the payment method of your choice.

              <br /><br />

              <strong style="font-size: 16px;">Step 5:</strong><br /> Setup Auto Recharge So You Never Run Out Of Funds
              <br />
              Go to Payment settings - Auto Recharge Suggest to start when balance goes between $10 you add $20.

              <br /><br />

              <strong style="font-size: 16px;">Step 6:</strong><br /> Purchase Phone Number

              <br /><br />

              <strong style="font-size: 16px;">Step 7:</strong><br /> Select Phone Number To Use In Local Lead Sniper

              <br /><br />

              <strong style="font-size: 16px;">***</strong> If you already have a twilio account, you can use that. Do Step 3, then Step 6. We recommend you purchase a dedicated number to use with Local Lead Sniper.
            </div>
            <div class="w-full sm:w-1/2">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 10px;">Sign Up Example Video</div>

              <!-- <iframe src="https://share.getcloudapp.com/NQu4np2A?branding=true&amp;embed=true&amp;title=true" width="100%" height="400px" style="border:none" frameborder="0" allowtransparency="true" allowfullscreen="true"></iframe> -->
              <div style="padding:93.43% 0 0 0;position:relative;">
                <iframe src="https://player.vimeo.com/video/961196019?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Sign Up Example Video"></iframe>
              </div>

              <br /><br />

              <div style="font-weight: bold; font-size: 14px; margin-bottom: 10px;">Purchase Number Example Video</div>

              <!-- <iframe src="https://share.getcloudapp.com/v1uEzo8Y?branding=true&amp;embed=true&amp;title=true" width="100%" height="400px" style="border:none" frameborder="0" allowtransparency="true" allowfullscreen="true"></iframe> -->
                <div style="padding:94.5% 0 0 0;position:relative;">
                  <iframe src="https://player.vimeo.com/video/961195937?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Purchase Number Example Video"></iframe>
                </div>
            </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="watch_twilio_tutorial = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="watch_google_tutorial" @click.self="watch_google_tutorial = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="bg-white rounded-lg mx-6" style="width: 90%;overflow-x: auto;">

        <div class="rg-modal-header">
          Google Maps Setup Video Tutorial

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="watch_google_tutorial = false"><i class="fa fa-times"></i></a>
        </div>

        <div class="p-6" style="font-size: 12px;">

          <div class="flex flew-row flex-wrap">
            <div class="w-full sm:w-1/2 pr-10" style="font-size: 14px;">
              <strong style="font-size: 16px;">Step 1:</strong><br /> Setup Google Cloud<br />
              Signup here: <a href="https://developers.google.com/maps" target="_BLANK">https://developers.google.com/maps</a>
              <br />
              Login with whatever google account you choose. (Doesn’t matter which)

              <br /><br />

              <strong style="font-size: 16px;">Step 2:</strong><br /> Setup Billing Accounts<br />
              Click Manage Billing Accounts
              <br />
              Click Create Account Name the Account & Set Your Country
              <br />
              Create payments profile with your billing info and credit card and click button submit and enable billing.

              <br /><br />

              <strong style="font-size: 16px;">Step 3:</strong><br /> Setup New Project<br />
              Choose any name and location you wish.
              <br />
              Select the project you just created In top left navigation choose API & Services - Library
              <br />
              In the search - type places API & then click on it. Click enable.
              <br />
              Uncheck the first option “Enable all Google Maps APIS for this project.” And click go to google maps platform.

              <br /><br />

              <strong style="font-size: 16px;">Step 4:</strong><br /> Enable APIs
              <br />
              Click On APIs in left navigation.
              <br />
              Click on Geocoding API and enable.

              <br /><br />

              <strong style="font-size: 16px;">Step 5:</strong><br /> Copy & Paste API Key
              <br />

              Click Credentials - Maps Key & Copy API Key Into Local Lead Sniper
            </div>
            <div class="w-full sm:w-1/2">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 10px;">Example Video</div>

              <!-- <iframe src="https://share.getcloudapp.com/bLuOQEb1?branding=true&amp;embed=true&amp;title=true" width="100%" height="400" style="border:none" frameborder="0" allowtransparency="true" allowfullscreen="true"></iframe> -->
              <div style="padding:74.9% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/961195824?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Google Maps Setup Video Tutorial"></iframe></div>
            </div>
          </div>

        </div>

        <!-- <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="watch_google_tutorial = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div> -->

      </div>
    </div>

    <div v-if="watch_valueserp_tutorial" @click.self="watch_valueserp_tutorial = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="bg-white rounded-lg mx-6" style="width: 1000px; max-width: 100%;">

        <div class="rg-modal-header">
          ValueSERP Setup Video Tutorial

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="watch_valueserp_tutorial = false"><i class="fa fa-times"></i></a>
        </div>

        <div class="p-6" style="font-size: 12px;">

          <div class="flex flew-row flex-wrap">
            <div class="w-full sm:w-1/2 pr-10" style="font-size: 14px;">
              <strong style="font-size: 16px;">Step 1:</strong><br /> Create An Account<br />
              Signup here: <a href="https://app.valueserp.com/signup" target="_BLANK">https://app.valueserp.com/signup</a>

              <br /><br />

              <strong style="font-size: 16px;">Step 2:</strong><br /> Verify Your eMail Address<br />
              Go to your email and click on the verification link.

              <br /><br />

              <strong style="font-size: 16px;">Step 3:</strong><br /> Copy & Paste API Key<br />
              Copy API Key Into Local Lead Sniper.
            </div>
            <div class="w-full sm:w-1/2">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 10px;">Example Video</div>

              <!-- <iframe src="https://share.getcloudapp.com/NQu4ALYy?branding=true&amp;embed=true&amp;title=true" width="100%" height="400" style="border:none" frameborder="0" allowtransparency="true" allowfullscreen="true"></iframe> -->
              <div style="padding:76.9% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/961195881?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="ValueSERP Setup Video Tutorial"></iframe></div>
            </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="watch_valueserp_tutorial = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="watch_signalwire_tutorial" @click.self="watch_signalwire_tutorial = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="bg-white rounded-lg mx-6" style="width: 1000px; max-width: 100%;">

        <div class="rg-modal-header">
          SignalWire Setup Video Tutorial

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="watch_signalwire_tutorial = false"><i class="fa fa-times"></i></a>
        </div>

        <div class="p-6" style="font-size: 12px;">

          <div class="flex flew-row flex-wrap">
            <div class="w-full sm:w-1/2 pr-10" style="font-size: 14px;">
              <strong style="font-size: 16px;">Step 1:</strong><br /> Create An Account<br />
              Signup here: <a href="https://signalwire.com" target="_BLANK">https://signalwire.com</a>

              <br /><br />

              <strong style="font-size: 16px;">Step 2:</strong><br /> Verify Your Phone Number<br />
              Check your phone for code received and verify your phone number.

              <br /><br />

              <strong style="font-size: 16px;">Step 3:</strong><br /> Add Company Name, Role & Interests<br />
              These really have no implications but need to be filled in.

              <br /><br />

              <strong style="font-size: 16px;">Step 4:</strong><br /> Setup New API Token<br />
              Name whatever you like & click save

              <br /><br />

              <strong style="font-size: 16px;">Step 5:</strong><br /> Copy & Paste Credentials<br />
              Copy and paste your token
              <br />
              Then copy and paste your namespace
              <br />
              Lastly copy and paste your Project ID Into Local Lead Sniper.
            </div>
            <div class="w-full sm:w-1/2">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 10px;">Example Video</div>

              <!-- <iframe src="https://share.getcloudapp.com/jkuOp2Rw?branding=true&amp;embed=true&amp;title=true" width="100%" height="400" style="border:none" frameborder="0" allowtransparency="true" allowfullscreen="true"></iframe> -->
              <div style="padding:77.16% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/961202606?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="SignalWire Setup Video Tutorial"></iframe></div>
            </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="watch_signalwire_tutorial = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="watch_scrapingdog_tutorial" @click.self="watch_scrapingdog_tutorial = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="bg-white rounded-lg mx-6" style="width: 1000px; max-width: 100%;">

        <div class="rg-modal-header">
          ScrapingDog Setup Video Tutorial

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="watch_scrapingdog_tutorial = false"><i class="fa fa-times"></i></a>
        </div>

        <div class="p-6" style="font-size: 12px;">

          <div class="flex flew-row flex-wrap">
            <div class="w-full sm:w-1/2 pr-10" style="font-size: 14px;">
              <strong style="font-size: 16px;">Step 1:</strong><br /> Create An Account<br />
              Signup here: <a href="https://api.scrapingdog.com/register" target="_BLANK">https://api.scrapingdog.com/register</a>

              <br /><br />

              <strong style="font-size: 16px;">Step 2:</strong><br /> Verify Your eMail Address<br />
              Go to your email and click on the verification link.

              <br /><br />

              <strong style="font-size: 16px;">Step 3:</strong><br /> Copy & Paste API Key<br />
              Copy API Key Into Local Lead Sniper.

              <br /><br />

              <strong style="font-size: 16px;">Step 4:</strong><br /> Choose Which Functions To Use Scraping Dog For<br />
            </div>
            <div class="w-full sm:w-1/2">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 10px;">Example Video</div>

              <!-- <iframe src="https://share.getcloudapp.com/2Nu68dN5?branding=true&amp;embed=true&amp;title=true" width="100%" height="400" style="border:none" frameborder="0" allowtransparency="true" allowfullscreen="true"></iframe> -->
              <div style="padding:77.06% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/961195728?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="ScrapingDog Setup Video Tutorial"></iframe></div>
            </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="watch_scrapingdog_tutorial = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="show_twilio_popup" @click.self="show_twilio_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          Twilio Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_twilio_popup = false"><i class="fa fa-times"></i></a>
        </div>

        <div class="p-6">

          <div class="float-right -mb-4" style="position: relative;">
            <a href="https://www.twilio.com/try-twilio" class="text-xs" target="lfp-twilio-link">Sign Up for Twilio</a>
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">
            <div :class="'w-full mb-3'">
              <p class="mb-1 text-xs mb-2"><strong>Account SID</strong></p>
              <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"
              :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
              v-model="me.integrations.twilio.settings.account_sid"  />
            </div>
            <div :class="'w-full mb-3'" style="position: relative;">
              <p class="mb-1 text-xs mb-2"><strong>Auth Token</strong></p>
              <input :type="((show_auth_token) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.twilio.settings.auth_token" style="padding-right: 35px !important;"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
              />

              <a href="javascript: void(0);" @click="show_auth_token = !show_auth_token" class="token_password_toggle">
                <i v-if="show_auth_token" class="fa fa-eye"></i>
                <i v-if="!show_auth_token" class="fa fa-eye-slash"></i>
              </a>
            </div>

            <div class="w-full mb-3 ">

              <div v-if="errorTwilio" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
                <div v-html="errorTwilio"> </div>
              </div>

              <p v-if="me.integrations.twilio.status == 1" class="mb-1 text-xs mb-2"><strong>Outgoing SMS Phone Number</strong></p>
              
              <v-select v-if="me.integrations.twilio.status == 1 && !gettingTwilioNumbers"
                    v-model="me.integrations.twilio.settings.phone_number"
                    outlined dense
                    hide-details
                    :items="me.integrations.twilio.settings.numbers"
                    class="-mt-2"
                ></v-select>

              <div v-if="me.integrations.twilio.status == 1 && me.integrations.twilio.settings.numbers.length == 0 && !gettingTwilioNumbers" class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 mb-4 mt-1" role="warning">
                <div>Please purchase a phone number.</div>
              </div>

                <i v-if="gettingTwilioNumbers" class="fa fa-spin fa-spinner" style="font-size: 14px;"></i>
            </div>
          </div>

          <v-chip
            v-if="me.integrations.twilio.status == 1 && me.integrations.twilio.settings.phone_number"
            class="mt-2"
            small
            color="green lighten-5"
            text-color="green lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
            Connected
          </v-chip>

          <v-chip
            v-else
            class="mt-2"
            small
            color="red lighten-5"
            text-color="red lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-close mr-1"></i>
            Not Connected
          </v-chip>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingTwilio}" @click="saveTwilioSettings">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_twilio_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="show_google_maps_popup" @click.self="show_google_maps_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          Google Maps Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_google_maps_popup = false"><i class="fa fa-times"></i></a>
        </div>

        <div class="p-6">

          <div class="float-right -mb-4" style="position: relative;">
            <a href="https://developers.google.com/maps" class="text-xs" target="lfp-gmaps-link">Sign Up for Google Maps API</a>
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">
            <div :class="'w-full' + (($vuetify.breakpoint.xs) ? '' : '')">
              <p class="mb-1 text-xs mb-2"><strong>API Key</strong></p>
              <input :type="((show_maps_key) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.google_maps.settings.api_key" style="padding-right: 35px !important;" />

              <a href="javascript: void(0);" @click="show_maps_key = !show_maps_key" class="token_password_toggle">
                <i v-if="show_maps_key" class="fa fa-eye"></i>
                <i v-if="!show_maps_key" class="fa fa-eye-slash"></i>
              </a>
            </div>
          </div>

          <div v-if="errorGoogleMaps" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
            <div v-html="errorGoogleMaps"> </div>
          </div>

          <v-chip
            v-if="me.integrations.google_maps.settings.api_key && me.integrations.google_maps.status == 1"
            class="mt-2"
            small
            color="green lighten-5"
            text-color="green lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
            Connected
          </v-chip>

          <v-chip
            v-else
            class="mt-2"
            small
            color="red lighten-5"
            text-color="red lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-close mr-1"></i>
            Not Connected
          </v-chip>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingGoogleMapsKey}" @click="saveGoogleMapsKey">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_google_maps_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="show_value_serp_popup" @click.self="show_value_serp_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          ValueSerp Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_value_serp_popup = false"><i class="fa fa-times"></i></a>
        </div>

        <div class="p-6">
          
          <div class="float-right -mb-4" style="position: relative;">
            <a href="https://app.valueserp.com/signup" class="text-xs" target="lfp-gmaps-link">Sign Up for ValueSerp</a>
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">
            <div class="w-full">
              <p class="mb-1 text-xs mb-2"><strong>API Key</strong></p>
              <input :type="((show_value_serp_key) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.value_serp.settings.api_key" style="padding-right: 35px !important;" />

              <a href="javascript: void(0);" @click="show_value_serp_key = !show_value_serp_key" class="token_password_toggle">
                <i v-if="show_value_serp_key" class="fa fa-eye"></i>
                <i v-if="!show_value_serp_key" class="fa fa-eye-slash"></i>
              </a>
            </div>
          </div>

          <div v-if="errorValueSerp" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
            <div v-html="errorValueSerp"> </div>
          </div>

          <v-chip
            v-if="me.integrations.value_serp.settings.api_key && me.integrations.value_serp.status == 1"
            class="mt-2"
            small
            color="green lighten-5"
            text-color="green lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
            Connected
          </v-chip>

          <v-chip
            v-else
            class="mt-2"
            small
            color="red lighten-5"
            text-color="red lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-close mr-1"></i>
            Not Connected
          </v-chip>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingValueSerpKey}" @click="saveValueSerpKey">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_value_serp_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="show_signal_wire_popup" @click.self="show_signal_wire_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          ValueSerp Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_signal_wire_popup = false"><i class="fa fa-times"></i></a>
        </div>

        <div class="p-6">
          
          <div class="float-right -mb-4" style="position: relative;">
            <a href="https://id.signalwire.com/signup/account/new" class="text-xs" target="lfp-gmaps-link">Sign Up for SignalWire</a>
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">
              <div :class="'w-full' + (($vuetify.breakpoint.xs) ? '' : '')">
                <p class="mb-1 text-xs mb-2"><strong>Namespace</strong></p>
                <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" placeholder="yoursubdomain.signalwire.com"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                v-model="me.integrations.signalwire.settings.namespace"  />
              </div>
              <div :class="'w-full' + (($vuetify.breakpoint.xs) ? '' : '')" style="position: relative;">
                <p class="mb-1 text-xs mb-2"><strong>Project ID</strong></p>
                <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                v-model="me.integrations.signalwire.settings.project_id"  />
              </div>
              <div :class="'w-full' + (($vuetify.breakpoint.xs) ? '' : '')" style="position: relative;">
                <p class="mb-1 text-xs mb-2"><strong>API Token</strong></p>
                <input :type="((show_signalwire_api_token) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.signalwire.settings.api_token" style="padding-right: 35px !important;" />

                <a href="javascript: void(0);" @click="show_signalwire_api_token = !show_signalwire_api_token" class="token_password_toggle">
                  <i v-if="show_signalwire_api_token" class="fa fa-eye"></i>
                  <i v-if="!show_signalwire_api_token" class="fa fa-eye-slash"></i>
                </a>
              </div>
            </div>

            <div v-if="errorSignalWire" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
              <div v-html="errorSignalWire"> </div>
            </div>

          <v-chip
            v-if="me.integrations.signalwire.status == 1"
            class="mt-2"
            small
            color="green lighten-5"
            text-color="green lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
            Connected
          </v-chip>

          <v-chip
            v-else
            class="mt-2"
            small
            color="red lighten-5"
            text-color="red lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-close mr-1"></i>
            Not Connected
          </v-chip>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingSignalWire}" @click="saveSignalWireSettings">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_signal_wire_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="show_scrapfly_popup" @click.self="show_scrapfly_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          ScrapingDog Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_scrapfly_popup = false"><i class="fa fa-times"></i></a>
        </div>

        <div class="p-6">
          
          <div class="float-right -mb-4" style="position: relative;">
            <a href="https://api.scrapingdog.com/register" class="text-xs" target="lfp-gmaps-link">Sign Up for ScrapingDog</a>
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">
            <div class="w-full">
              <p class="mb-1 text-xs mb-2"><strong>API Key</strong></p>
              <input :type="((show_scrapfly_key) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.scrapfly.settings.api_key" style="padding-right: 35px !important;" />

              <a href="javascript: void(0);" @click="show_scrapfly_key = !show_scrapfly_key" class="token_password_toggle">
                <i v-if="show_scrapfly_key" class="fa fa-eye"></i>
                <i v-if="!show_scrapfly_key" class="fa fa-eye-slash"></i>
              </a>
            </div>
          </div>

          <div style="clear: both; display: block; padding-right: 30px; padding-top: 10px;" v-on:click.stop>
            <div style="float: left;">
              <toggle-button color="#48bb78" :sync="true" v-model="me.integrations.scrapfly.settings.quote" />
            </div>
            <div style="float: left; padding-left: 10px; font-size: 12px;">
              Quote
            </div>
          </div>
          <div style="clear: both; display: block; padding-right: 30px; padding-top: 10px;" v-on:click.stop>
            <div style="float: left;">
              <toggle-button color="#48bb78" :sync="true" v-model="me.integrations.scrapfly.settings.chat" />
            </div>
            <div style="float: left; padding-left: 10px; font-size: 12px;">
              Chat
            </div>
          </div>
          <div style="clear: both; display: block; padding-right: 30px; padding-top: 10px;" v-on:click.stop>
            <div style="float: left;">
              <toggle-button color="#48bb78" :sync="true" v-model="me.integrations.scrapfly.settings.claimed" />
            </div>
            <div style="float: left; padding-left: 10px; font-size: 12px;">
              Claimed
            </div>
          </div>
          <div style="clear: both; display: block; padding-right: 30px; padding-top: 10px;" v-on:click.stop>
            <div style="float: left;">
              <toggle-button color="#48bb78" :sync="true" v-model="me.integrations.scrapfly.settings.posts" />
            </div>
            <div style="float: left; padding-left: 10px; font-size: 12px;">
              GBP Posts
            </div>
          </div>
          <div style="clear: both; display: block; padding-right: 30px; padding-top: 10px;" v-on:click.stop>
            <div style="float: left;">
              <toggle-button color="#48bb78" :sync="true" v-model="me.integrations.scrapfly.settings.screenshots" />
            </div>
            <div style="float: left; padding-left: 10px; font-size: 12px;">
              GBP Business Profile Screenshots
            </div>
          </div>

          <div style="clear: both;"></div>

            <div v-if="errorScrapfly" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
              <div v-html="errorScrapfly"> </div>
            </div>

          <v-chip
            v-if="me.integrations.scrapfly.status == 1"
            class="mt-2"
            small
            color="green lighten-5"
            text-color="green lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
            Connected
          </v-chip>

          <v-chip
            v-else
            class="mt-2"
            small
            color="red lighten-5"
            text-color="red lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-close mr-1"></i>
            Not Connected
          </v-chip>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingScrapfly}" @click="saveScrapflySettings">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_scrapfly_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <panel-navigation>
      
      <!-- <div style="float: right; margin-top: -7px;">
        <a href="https://Lead Finder.com/documentation/getting-started-guide/" target="agency-get-started-guide"><i class="fa fa-link"></i> Agency Getting Started Guide</a>
      </div> -->
      
      <div class="flex flex-row items-top justify-between">
        <h1 class="text-lg font-semibold mb-3">Settings</h1>
        <!-- <div class="bg-green-500 hover:bg-green-400 text-white inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': saving}" @click="save">Save</div> -->
      </div>
      
      <hr class="border-b border-gray-100 mb-3">

      <v-skeleton-loader
        type="article"
        v-if="!me"
      ></v-skeleton-loader>

      <div class="dashboard-box settings-wrapper" v-if="me">
        <v-card
          class="pa-2"
          tile
        >
          <div class="p-3 pt-1 pr-0">

            <template>
              <div class="flex flex-row flex-wrap -mx-3">

                <v-tabs>
                  <v-tab>My Profile</v-tab>
                  <v-tab>Security</v-tab>
                  <v-tab>Billing</v-tab>
                  <v-tab>Integrations</v-tab>
                  <v-tab>Notifications</v-tab>
                  <v-tab>GHL Integration</v-tab>

                  <v-tab-item class="pt-7">
                    <div class="flex flew-row flex-wrap">
                      <div class="w-full sm:w-1/4 pr-6 mb-4 mt-2" style="text-align: center;">
                        <v-gravatar v-if="profile" class="gravatar-pic" :email="profile.email" default-img="https://regro-cdn.s3.amazonaws.com/images/profile_image.png" />
                        <br />
                        <strong>{{ profile.first_name }} {{ profile.last_name }}</strong>
                      </div>
                      <div class="w-full sm:w-3/4 mb-4">
                        <div class="flex flew-row flex-wrap">
                          <div class="w-full sm:w-1/2 pr-6 mb-4">
                            <p class="mb-1 text-xs mb-2"><strong>First Name</strong></p>
                            <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.first_name" />
                          </div>
                          <div class="w-full sm:w-1/2 mb-4">
                            <p class="mb-1 text-xs mb-2"><strong>Last Name</strong></p>
                            <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.last_name" />
                          </div>
                          <div class="w-full mb-4">
                            <p class="mb-1 text-xs mb-2"><strong>Email</strong></p>
                            <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.email" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr class="mt-3" />

                    <div>
                      <div class="bg-blue-500 float-right hover:bg-blue-400 text-white text-sm inline-block rounded py-2 px-3 cursor-pointer mt-6" :class="{'spinner': saving}" @click="save()">Save</div>
                    </div>
                  </v-tab-item>
                  <v-tab-item class="pt-5">
                    <div class="w-full sm:w-1/3 pr-6 mb-4">
                      <p class="mb-1 text-xs mb-2"><strong>Current Password</strong></p>
                      <input type="password" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" ref="current_password" />
                    </div>
                    <div class="w-full sm:w-1/3 pr-6 mb-4">
                      <p class="mb-1 text-xs mb-2"><strong>New Password</strong></p>
                      <input type="password" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" ref="new_password" />
                    </div>
                    <div class="w-full sm:w-1/3 pr-6 mb-4">
                      <p class="mb-1 text-xs mb-2"><strong>Confirm Password</strong></p>
                      <input type="password" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" ref="confirm_password" />
                    </div>

                    <div v-if="error_password" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
                      <div v-html="error_password"></div>
                    </div>

                    <hr class="mt-3" />

                    <div class="float-right mt-6">
                      <v-chip
                        v-if="password_changed"
                        class="ma-2 mt-2 ml-3"
                        color="green"
                        outlined
                        @click="password_changed = false"
                        style="position: absolute;"
                      >
                        <v-icon left>
                          mdi-check
                        </v-icon>
                        Password changed!
                      </v-chip>

                      <div class="bg-blue text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': changing}" @click="change_password">Change Password</div>
                    </div>
                  </v-tab-item>

                  <v-tab-item>
                    <div class="mt-3" style="background: #f0f0f0; border-radius: 5px; padding: 30px;">
                      <div style="color: #19233A; font-size: 16px;; font-weight: bold;">Current Plan</div>

                      <div style="font-size: 12px; color: #19233A; font-weight: bold; padding-top: 10px;">{{ me.plan_name }}</div>

                      <div style="font-size: 12px; color: #757B89; padding-top: 10px;">
                        On Time Unlock:
                      
                        <strong v-if="me.one_time == 1" class="text-success">Yes</strong>
                        <strong v-if="me.one_time == 0" class="text-danger">No</strong>
                      </div>
                    </div>

                  </v-tab-item>
                  
                  <v-tab-item>
                    <h2 class="font-bold text-gray-800 mt-5">Connected Apps</h2>

                    <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="show_twilio_popup = true">
                      <div style="float: left; padding-top: 7px; padding-left: 10px">
                        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20.7966 25.281L20.6014 25.086H20.3255H5.09482C3.08178 25.086 1.43229 23.3966 1.43229 21.3313V4.78314C1.43229 2.71822 3.08136 1.03193 5.09482 1.03193L27.9749 1.0319C29.9884 1.0319 31.6375 2.71849 31.6375 4.78311V21.3313C31.6375 23.3966 29.988 25.086 27.9749 25.086H27.0746H26.4079V25.7527V30.1774C26.4078 30.2951 26.3369 30.4014 26.2271 30.4467L26.2264 30.447C26.1165 30.4925 25.9899 30.4673 25.9061 30.3836L20.7966 25.281ZM5.09482 1.61541H4.5334L4.52432 1.66798C3.08262 1.93775 2.01968 3.21586 2.01968 4.78319V21.3313C2.01968 23.098 3.37118 24.5025 5.09481 24.5025H20.7238C20.8021 24.5025 20.8769 24.5336 20.932 24.5885L24.6833 28.3358L25.8211 29.4723V27.8641V24.7941C25.8211 24.6342 25.9512 24.5025 26.1147 24.5025H27.9757C29.6993 24.5025 31.0508 23.0979 31.0508 21.3313V4.78314C31.0508 3.01491 29.6984 1.61541 27.9757 1.61541H5.09482Z" fill="#3A9BDB" stroke="#3A9BDB" stroke-width="1.33333"/>
                        </svg>
                      </div>

                      <div style="float: left; padding-left: 30px; width: calc(100% - 200px);">
                        <div style="color: #19233A; font-size: 14px; font-weight: bold;">Twilio</div>

                        <div class="text-sm text-gray-600">
                          We use Twilio to send SMS and lookup the phone numbers type and carrier on your search results.
                        </div>

                        <div style="padding-top: 10px; font-size: 14px; font-weight: bold;">
                          <a href="javascript: void(0);" @click.stop="watch_twilio_tutorial = true"><i class="mdi mdi-movie-outline"></i> Watch Video Tutorial</a>
                        </div>
                      </div>

                      <div style="float: right;">
                        <v-chip
                          v-if="me.integrations.twilio.status == 1 && me.integrations.twilio.settings.phone_number"
                          class="ma-2"
                          small
                          color="green lighten-5"
                          text-color="green lighten-1"
                          @click="saved = false"
                        >
                          <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                          Connected
                        </v-chip>

                        <v-chip
                          v-else
                          class="ma-2"
                          small
                          color="red lighten-5"
                          text-color="red lighten-1"
                          @click="saved = false"
                        >
                          <i class="mdi mdi-close mr-1"></i>
                          Not Connected
                        </v-chip>
                      </div>

                      <div style="clear: both;"></div>
                    </div>

                    <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="show_google_maps_popup = true">
                      <div style="float: left; padding-top: 7px; padding-left: 10px">
                        <svg width="33" height="33" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_1135_8653)">
                          <path d="M32.7247 30.6683C33.1407 30.2531 33.8151 30.2531 34.2311 30.6683L43.826 40.2437C44.242 40.6588 44.242 41.3319 43.826 41.747C43.4101 42.1621 42.7356 42.1621 42.3196 41.747L32.7247 32.1716C32.3087 31.7565 32.3087 31.0834 32.7247 30.6683Z" fill="#3A9BDB" stroke="#3A9BDB"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M38.0113 21.3327C38.0113 13.2785 31.4688 6.74935 23.3983 6.74935C15.3277 6.74935 8.78516 13.2785 8.78516 21.3327C8.78516 29.3868 15.3277 35.916 23.3983 35.916C31.4688 35.916 38.0113 29.3868 38.0113 21.3327ZM34.88 21.3327C34.88 15.0044 29.7394 9.87435 23.3983 9.87435C17.0571 9.87435 11.9165 15.0044 11.9165 21.3327C11.9165 27.6609 17.0571 32.791 23.3983 32.791C29.7394 32.791 34.88 27.6609 34.88 21.3327Z" fill="#3A9BDB"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_1135_8653">
                          <rect width="50.102" height="50" fill="white" transform="translate(0.43457 0.5)"/>
                          </clipPath>
                          </defs>
                        </svg>
                      </div>

                      <div style="float: left; padding-left: 30px; width: calc(100% - 200px);">
                        <div style="color: #19233A; font-size: 14px; font-weight: bold;">Google Maps</div>

                        <div class="text-sm text-gray-600">
                          Google Maps is used for finding businesses using your search criteria.

                          API's needed: <strong>Geocoding API</strong> and <strong>Places API</strong>

                          <div style="padding-top: 5px; font-size: 12px;">
                            <strong>&#9679;</strong> Please make sure billing is enabled in your Google Maps account before adding your key.
                          </div>

                          <div style="padding-top: 5px; font-size: 12px;">
                            <strong>&#9679;</strong> Google offers $200 in free monthly credits. A search will cost on average around $0.25, it may cost more for Multi-Snipe searches.
                          </div>

                          <div style="padding-top: 5px; font-size: 12px;">
                            <strong>&#9679;</strong> If you start going over your $200/mo in free usage we'd recommend using ValueSerp.
                          </div>

                          <div style="padding-top: 10px; font-size: 14px; font-weight: bold;">
                            <a href="javascript: void(0);" @click.stop="watch_google_tutorial = true"><i class="mdi mdi-movie-outline"></i> Watch Video Tutorial</a>
                          </div>
                        </div>
                      </div>

                      <div style="float: right;">
                        <v-chip
                          v-if="me.integrations.google_maps.settings.api_key && me.integrations.google_maps.status == 1"
                          class="ma-2"
                          small
                          color="green lighten-5"
                          text-color="green lighten-1"
                          @click="saved = false"
                        >
                          <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                          Connected
                        </v-chip>

                        <v-chip
                          v-else
                          class="ma-2"
                          small
                          color="red lighten-5"
                          text-color="red lighten-1"
                          @click="saved = false"
                        >
                          <i class="mdi mdi-close mr-1"></i>
                          Not Connected
                        </v-chip>
                      </div>

                      <div style="clear: both;"></div>
                    </div>

                    <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="show_value_serp_popup = true">
                      <div style="float: left; padding-top: 7px; padding-left: 10px">
                        <svg width="33" height="33" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_1135_8653)">
                          <path d="M32.7247 30.6683C33.1407 30.2531 33.8151 30.2531 34.2311 30.6683L43.826 40.2437C44.242 40.6588 44.242 41.3319 43.826 41.747C43.4101 42.1621 42.7356 42.1621 42.3196 41.747L32.7247 32.1716C32.3087 31.7565 32.3087 31.0834 32.7247 30.6683Z" fill="#3A9BDB" stroke="#3A9BDB"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M38.0113 21.3327C38.0113 13.2785 31.4688 6.74935 23.3983 6.74935C15.3277 6.74935 8.78516 13.2785 8.78516 21.3327C8.78516 29.3868 15.3277 35.916 23.3983 35.916C31.4688 35.916 38.0113 29.3868 38.0113 21.3327ZM34.88 21.3327C34.88 15.0044 29.7394 9.87435 23.3983 9.87435C17.0571 9.87435 11.9165 15.0044 11.9165 21.3327C11.9165 27.6609 17.0571 32.791 23.3983 32.791C29.7394 32.791 34.88 27.6609 34.88 21.3327Z" fill="#3A9BDB"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_1135_8653">
                          <rect width="50.102" height="50" fill="white" transform="translate(0.43457 0.5)"/>
                          </clipPath>
                          </defs>
                        </svg>
                      </div>

                      <div style="float: left; padding-left: 30px; width: calc(100% - 200px);">
                        <div style="color: #19233A; font-size: 14px; font-weight: bold;">ValueSerp</div>

                        <div class="text-sm text-gray-600">
                          ValueSerp is used as an alternative for Google Maps API (optional).

                          <div style="padding-top: 5px; font-size: 12px;">
                            <strong>&#9679;</strong> ValueSerp costs $1.50 per 1,000 requests.
                          </div>

                          <div style="padding-top: 5px; font-size: 12px;">
                            <strong>&#9679;</strong> We suggest integrating ValueSerp if you go over $200 usage in Google credits.
                          </div>

                          <div style="padding-top: 10px; font-size: 14px; font-weight: bold;">
                            <a href="javascript: void(0);" @click.stop="watch_valueserp_tutorial = true"><i class="mdi mdi-movie-outline"></i> Watch Video Tutorial</a>
                          </div>
                        </div>
                      </div>

                      <div style="float: right;">
                        <v-chip
                        v-if="me.integrations.value_serp.settings.api_key && me.integrations.value_serp.status == 1"
                          class="ma-2"
                          small
                          color="green lighten-5"
                          text-color="green lighten-1"
                          @click="saved = false"
                        >
                          <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                          Connected
                        </v-chip>

                        <v-chip
                          v-else
                          class="ma-2"
                          small
                          color="red lighten-5"
                          text-color="red lighten-1"
                          @click="saved = false"
                        >
                          <i class="mdi mdi-close mr-1"></i>
                          Not Connected
                        </v-chip>
                      </div>

                      <div style="clear: both;"></div>
                    </div>

                    <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="show_signal_wire_popup = true">
                      <div style="float: left; padding-top: 7px; padding-left: 10px">
                        <svg width="35" height="21" viewBox="0 0 41 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M33.3484 14.308H33.316L33.3028 14.3376L29.9668 21.7837L25.3915 0.782325L25.2936 0.783146L21.7503 18.4669L19.1587 9.91203L19.1124 9.75917L19.0633 9.91115L14.7893 23.1345L10.2783 7.7877L10.247 7.68107L10.188 7.77526L5.21541 15.7139H0.609375H0.559375V15.7639V17.2319V17.2819H0.609375H6.05852H6.08621L6.1009 17.2584L9.72435 11.4732L14.6724 28.3071L14.7181 28.4626L14.768 28.3083L19.0637 15.0172L22.0026 24.7201L22.0995 24.7154L25.405 8.22272L29.4161 26.635L29.4484 26.7835L29.5105 26.6448L34.3345 15.876H40.8173H40.8673V15.826V14.358V14.308H40.8173H33.3484Z" fill="#3A9BDB" stroke="#3A9BDB" stroke-width="0.1"/>
                        </svg>
                      </div>

                      <div style="float: left; padding-left: 30px; width: calc(100% - 200px);">
                        <div style="color: #19233A; font-size: 14px; font-weight: bold;">Signal Wire</div>

                        <div class="text-sm text-gray-600">
                          SignalWire is required to look up the phone type of a Canadian phone number.
                        </div>

                        <div style="padding-top: 10px; font-size: 14px; font-weight: bold;">
                          <a href="javascript: void(0);" @click.stop="watch_signalwire_tutorial = true"><i class="mdi mdi-movie-outline"></i> Watch Video Tutorial</a>
                        </div>
                      </div>

                      <div style="float: right;">
                        <v-chip
                          v-if="me.integrations.signalwire.status == 1"
                          class="ma-2"
                          small
                          color="green lighten-5"
                          text-color="green lighten-1"
                          @click="saved = false"
                        >
                          <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                          Connected
                        </v-chip>

                        <v-chip
                          v-else
                          class="ma-2"
                          small
                          color="red lighten-5"
                          text-color="red lighten-1"
                          @click="saved = false"
                        >
                          <i class="mdi mdi-close mr-1"></i>
                          Not Connected
                        </v-chip>
                      </div>

                      <div style="clear: both;"></div>
                    </div>

                    <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="show_scrapfly_popup = true">
                      <div style="float: left; padding-top: 3px; padding-left: 13px">
                        <i class="mdi mdi-web-plus" style="color: #3A9BDB; font-size: 26px;"></i>
                      </div>

                      <div style="float: left; padding-left: 35px; width: calc(100% - 200px);">
                        <div style="color: #19233A; font-size: 14px; font-weight: bold;">ScrapingDog</div>

                        <div class="text-sm text-gray-600">
                          We use ScrapingDog to extract additional information for the GMB, such as whether they have a Quote or Chat button, if they're claimed and if they published any posts.

                          <div style="clear: both;"></div>
                        </div>

                        <div style="padding-top: 10px; font-size: 14px; font-weight: bold;">
                          <a href="javascript: void(0);" @click.stop="watch_scrapingdog_tutorial = true"><i class="mdi mdi-movie-outline"></i> Watch Video Tutorial</a>
                        </div>
                      </div>

                      <div style="float: right;">
                        <v-chip
                          v-if="me.integrations.scrapfly.status == 1"
                          class="ma-2"
                          small
                          color="green lighten-5"
                          text-color="green lighten-1"
                          @click="saved = false"
                        >
                          <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                          Connected
                        </v-chip>

                        <v-chip
                          v-else
                          class="ma-2"
                          small
                          color="red lighten-5"
                          text-color="red lighten-1"
                          @click="saved = false"
                        >
                          <i class="mdi mdi-close mr-1"></i>
                          Not Connected
                        </v-chip>
                      </div>

                      <div style="clear: both;"></div>
                    </div>

                  </v-tab-item>

                  <v-tab-item class="pt-5 pl-2">
                    
                    <div class="mb-1 text-xs mb-4">
                      <div class="float-left mr-3"><strong>Email</strong></div>
                      <div class="float-left">
                        <v-switch color="#3A9BDB" inset dense hide-details :ripple="false" v-model="me.settings.email_enabled"></v-switch>
                      </div>
                      <div class="clearfix"></div>
                    </div>

                    <p v-show="me.settings.email_enabled" class="mb-1 text-xs mb-2"><strong>Enter email addresses</strong></p>

                    <v-combobox
                      v-show="me.settings.email_enabled"
                      v-model="me.settings.email_addresses"
                      multiple
                      small-chips
                      color="blue"
                      outlined
                      dense
                    ></v-combobox>

                    <div class="mb-1 text-xs mb-4 mt-6">
                      <div class="float-left mr-3"><strong>SMS</strong></div>
                      <div class="float-left">
                        <v-switch color="#3A9BDB" inset dense hide-details :ripple="false" v-model="me.settings.sms_enabled"></v-switch>
                      </div>
                      <div class="clearfix"></div>
                    </div>

                    <p v-show="me.settings.sms_enabled" class="mb-1 text-xs mb-2"><strong>Enter phone numbers</strong></p>

                    <v-combobox
                      v-show="me.settings.sms_enabled"
                      v-model="me.settings.sms_numbers"
                      multiple
                      small-chips
                      color="blue"
                      outlined
                      dense
                    ></v-combobox>

                    <hr class="mt-3" />

                    <div class="float-right mt-6">
                      <div class="bg-blue text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': savingNotifications}" @click="saveNotifications()">Save Changes</div>
                    </div>
                  </v-tab-item>
                  
                  <v-tab-item class="pt-5 flex flex-wrap">
                      <!-- First Section -->
                      <div class="w-full md:w-1/2 pr-2 mb-4">
                        <h2 class="font-bold text-gray-800 mt-5">Connect to High Level</h2>
                        <div class="mt-3 w-full bg-gray-200 " style="background: rgb(245, 245, 245);border-radius: 5px;padding: 10px;">
                            <div style="font-size: 12px; color: rgb(25, 35, 58); font-weight: bold; padding-top: 10px;">Add your High Level Location API key to connect</div>
                            <div class="text-sm text-gray-600 mt-2">
                              Find this in your [Settings] -> [Company] page
                            </div>
                            
                            <p class="mb-1 text-md mt-5 mb-2"><strong>Location API Key</strong></p>
                              <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.ghl_api" />

                              <div class="w-full flex space-x-4 mt-5">
                                  <!-- Save Button -->
                                  <div class="bg-blue-500 hover:bg-blue-400 text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" 
                                      :class="{'spinner': saving}" 
                                      @click="save()">
                                    Save
                                  </div>

                                  <!-- Get API Key Button -->
                                  <a href="https://app.gohighlevel.com/settings/api_key" target="_blank" 
                                    class="border-1 border-blue text-primary text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ">
                                    <i class="fa fa-link mr-2"></i>
                                    Get Location API Key
                                  </a>
                              </div>
                        </div>
                      </div>

                      <!-- Second Section -->
                      <div class="w-full md:w-1/2 pr-2 mb-4">
                        <h2 class="font-bold text-gray-800 mt-5">Custom Menu Link for High Level CRM</h2>
                        <div class="mt-3 w-full bg-gray-200 " style="background: rgb(245, 245, 245);border-radius: 5px;padding: 10px;">
                          <div class="text-sm text-gray-600 mt-2">
                               Copy the code below and paste it into a Custom Menu Link URL

                          </div>
                          <textarea 
                            id="customMenuLink"
                            class="mt-4 w-full mb-2 p-2 text-gray-700 bg-white border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                            rows="4"
                            readonly
                            :value="apiEndpointIframe"
                          ></textarea>


                          <div class="w-full flex space-x-4 mt-2">
                              <button 
                                @click="copyToClipboard"
                                class="bg-blue-500 hover:bg-blue-400 text-white text-sm inline-block rounded py-2 px-3 cursor-pointer"
                              >
                                📋 Copy to Clipboard
                              </button>
                              <a href="https://app.gohighlevel.com/settings/company" target="_blank" 
                                    class="border-1 border-blue text-primary text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ">
                                    <i class="fa fa-link mr-2"></i>
                                    Open Agency Setting
                                </a>
                          </div>
                        </div>
                      </div>
                  </v-tab-item>

                </v-tabs>

                <v-alert v-if="me.integrations.twilio.status != 1 || me.integrations.google_maps.status != 1"
                  outlined
                  color="deep-orange"
                  icon="mdi-alert"
                  class="mt-3"
                >
                  Please configure your Twilio and Google Maps integrations before adding your searches.
                </v-alert>
              </div>
            </template>
          </div>
        </v-card>
      </div>

    </panel-navigation>
  </div>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import DialogSendTestEmail from '@/components/dialogs/integrations/sendTestEmail.vue'
import DialogViewIntegrationsInstructions from '@/components/dialogs/integrations/viewInstructions.vue'
import moment from 'moment'
import SmsTemplates from '@/views/panel/Templates.vue'
import ImageTemplates from '@/views/panel/PersonalizationImages.vue'

export default {
  metaInfo () {
    return {
      title: "Settings | " + this.$appName
    }
  },
  components: {
    PanelNavigation,
    ToggleButton,
    DialogSendTestEmail,
    DialogViewIntegrationsInstructions,
    SmsTemplates,
    ImageTemplates
  },
  data() {
    return {
      show_subdomain_field: false,
      userSegmentation: false,
      panel: [0],
      saving: false,
      error: null,

      changing: false,
      error_password: null,
      password_changed: false,

      savingDomain: false,
      errorDomain: null,

      file: null,
      file_favicon: null,
      uploading: false,
      uploading_favicon: false,

      agency_settings_saved: false,
      savingAgencySettings: false,

      savingTwilio: false,
      errorTwilio: null,
      gettingTwilioNumbers: false,
      show_auth_token: false,

      savingGoogleMapsKey: false,
      errorGoogleMaps: null,

      show_maps_key: false,

      savingSignalWire: false,
      errorSignalWire: null,
      show_signalwire_api_token: false,

      savingSMTP: false,
      errorSMTP: null,
      show_smtp_password: false,
      
      savingStripeSettings: false,
      stripeSettingsError:null,
      show_stripe_key: false,

      savingNotifications: false,

      savingValueSerpKey: false,
      errorValueSerp: null,

      savingScrapfly: false,
      errorScrapfly: null,

      show_value_serp_key: false,

      show_scrapfly_key: false,

      show_twilio_popup: false,
      show_google_maps_popup: false,
      show_value_serp_popup: false,
      show_signal_wire_popup: false,
      show_scrapfly_popup: false,

      watch_twilio_tutorial: false,
      watch_google_tutorial: false,
      watch_valueserp_tutorial: false,
      watch_signalwire_tutorial: false,
      watch_scrapingdog_tutorial: false
    }
  },
  methods: {
    watchVideoTutorial(integration, title) {
      this.videl_tutorial_title = title;
      this.watch_video_tutorial = true;
      this.video_tutorial_html_code = this.embed_codes[integration];
    },

    watchStepByStepInstructions(integration) {
      this.step_by_step_integration = integration;
      this.watch_step_by_step = true;
    },

    async save(ignore_number_verification = false) {
      let self = this;

      if (!ignore_number_verification) {
        if (!this.me.parent_id) {
          if (this.phone_number_changed && this.me.phone) {
            this.show_phone_verification_modal = true;
            setTimeout(function() {
              self.sendOtpSms();
            }, 300);
            return;
          }
        }
      }

      this.saving = true
      this.error = null

      try {
        await this.$store.dispatch('me/save', {
          first_name: this.me.first_name.trim(),
          last_name: this.me.last_name.trim(),
          email: this.me.email.trim(),
          ghl_api: this.me.ghl_api.trim()
        })
        this.$store.dispatch('me/fetch')
      }catch(error){
        console.log(error)
        this.error = error
      }

      this.saving = false

    },

    async change_password() {

      this.changing = true
      this.error_password = null

      try {
        await this.$store.dispatch('me/change_password', {
          current_password: this.$refs.current_password.value,
          new_password: this.$refs.new_password.value,
          confirm_password: this.$refs.confirm_password.value
        })
        
        this.password_changed = true

        this.$refs.current_password.value = '';
        this.$refs.new_password.value = '';
        this.$refs.confirm_password.value = '';
      } catch(error) {
        this.error_password = error
      }

      this.changing = false

      let self = this
      setTimeout(function() {
        self.password_changed = false
      }, 2000);
    },

    async saveNotifications() {

    this.savingNotifications = true

    try {

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/save-notification-settings`, {
        email_enabled: ((this.me.settings.email_enabled) ? 1 : 0),
        email_addresses: ((this.me.settings.email_addresses) ? this.me.settings.email_addresses : "_EMPTY_"),
        sms_enabled: ((this.me.settings.sms_enabled) ? 1 : 0),
        sms_numbers: ((this.me.settings.sms_numbers) ? this.me.settings.sms_numbers : "_EMPTY_")
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      }catch(error){
        // console.log(error)
        // this.error = error
      }

      this.savingNotifications = false
    },

    async saveDomain() {

      this.savingDomain = true
      this.errorDomain = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-white-label-domain`, {
        domain: ((this.$refs.domain) ? this.$refs.domain.value.trim() : this.me.domain)
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingDomain = false
        this.show_subdomain_field = false
        this.me.domain = ((this.$refs.domain) ? this.$refs.domain.value.trim() : this.me.domain)
        this.me.domain_status = response.data.domain_status
        this.me.ssl_status = response.data.ssl_status
        this.me.ssl_expiration = response.data.ssl_expiration
      }
      else {
        this.errorDomain = response.data.error
      }

      this.savingDomain = false
      let self = this

      setTimeout(function() {
        if (self.me.domain && (self.me.domain_status == 0 || self.me.ssl_status == 0)) {
          if (!self.show_subdomain_field)
            self.saveDomain();
        }
      }, 5000)

    },

    async saveAgencySettings() {

      this.savingAgencySettings = true
      this.agencySettingsError = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-stripe-settings`, {
        privacy_policy_link: this.me.integrations.stripe.settings.privacy_policy_link,
        terms_of_service_link: this.me.integrations.stripe.settings.terms_of_service_link,
        only_links: true
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.me.integrations.stripe.status = response.data.integration.status;
      this.me.integrations.stripe.settings = response.data.integration.settings;

      try {
        console.log('this.me.settings.custom_css', this.me.settings.custom_css)
        await this.$store.dispatch('me/save', {
          company_name: this.me.company_name.trim(),
          contacts_webhook: this.me.settings.contacts_webhook,
          custom_css: this.me.settings.custom_css || "{}",
          allow_business_to_modify_review_sites: this.me.settings.allow_business_to_modify_review_sites ? '1' : '0',
          allow_business_to_modify_sms_from_number: this.me.settings.allow_business_to_modify_sms_from_number ? '1' : '0',
          signup_link: this.me.settings.signup_link ? '1' : '0'
        })
        this.$store.dispatch('me/fetch')
      }catch(error){
        console.log(error)
        this.agencySettingsError = error
      }

      this.savingAgencySettings = false
      this.agency_settings_saved = true

      let self = this

      if (this.me.company_name.trim()) {
        this.$agency.company_name = this.me.company_name.trim()
        this.$appName = this.me.company_name.trim()
      }

      // if (this.me.settings.custom_css) {
        let css_el = document.querySelector("#rg-custom-css-sheet");
        css_el.innerText = this.me.settings.custom_css.replace(/\n/g, " ")
      // }

      setTimeout(() => {
        self.agency_settings_saved = false
      }, 2000);
    },

    async saveStripeSettings() {

      this.savingStripeSettings = true
      this.stripeSettingsError = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-stripe-settings`, {
        publishable_key: this.me.integrations.stripe.settings.publishable_key,
        secret_key: this.me.integrations.stripe.settings.secret_key,
        privacy_policy_link: this.me.integrations.stripe.settings.privacy_policy_link,
        terms_of_service_link: this.me.integrations.stripe.settings.terms_of_service_link
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingStripeSettings = false
        this.me.integrations.stripe.status = response.data.integration.status;
        this.me.integrations.stripe.settings = response.data.integration.settings;
      }
      else {
        this.stripeSettingsError = response.data.error
      }

      this.savingStripeSettings = false
    },

    async saveTwilioSettings() {

      this.savingTwilio = true
      this.errorTwilio = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-twilio-settings`, {
        account_sid: this.me.integrations.twilio.settings.account_sid,
        auth_token: this.me.integrations.twilio.settings.auth_token,
        phone_number: this.me.integrations.twilio.settings.phone_number || null
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingTwilio = false
        this.me.integrations.twilio.status = response.data.integration.status;

        if (response.data.integration.status == 0)
          this.errorTwilio = "Your Twilio credentials are invalid."
        else {
          // if (this.me.integrations.twilio.settings.numbers.length == 0)
          this.getTwilioNumbers()
        }
      }
      else {
        this.errorTwilio = response.data.error
      }

      this.savingTwilio = false

    },

    async saveGoogleMapsKey() {
      this.savingGoogleMapsKey = true
      this.errorGoogleMaps = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-google-maps-settings`, {
        api_key: this.me.integrations.google_maps.settings.api_key
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingGoogleMapsKey = false
        this.me.integrations.google_maps.status = response.data.integration.status;

        if (response.data.integration.status == 0)
          this.errorGoogleMaps = "Your Google Maps key is invalid."
      }
      else {
        this.errorGoogleMaps = response.data.error
      }

      this.savingGoogleMapsKey = false
    },

    async saveSignalWireSettings() {
      this.savingSignalWire = true
      this.errorSignalWire = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-signal-wire-settings`, {
        namespace: this.me.integrations.signalwire.settings.namespace,
        project_id: this.me.integrations.signalwire.settings.project_id,
        api_token: this.me.integrations.signalwire.settings.api_token
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingSignalWire = false
        this.me.integrations.signalwire.status = response.data.integration.status;

        if (response.data.integration.status == 0)
          this.errorSignalWire = "Your Signal Wire credentials are invalid."
      }
      else {
        this.errorSignalWire = response.data.error
      }

      this.savingSignalWire = false
    },

    async saveValueSerpKey() {
      this.savingValueSerpKey = true
      this.errorValueSerp = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-value-serp-settings`, {
        api_key: this.me.integrations.value_serp.settings.api_key
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingValueSerpKey = false
        this.me.integrations.value_serp.status = response.data.integration.status;

        if (response.data.integration.status == 0)
          this.errorValueSerp = "Your ValueSerp key is invalid."
      }
      else {
        this.errorValueSerp = response.data.error
      }

      this.savingValueSerpKey = false
    },

    async saveScrapflySettings() {
      this.savingScrapfly = true
      this.errorScrapfly = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-scrapfly-settings`, {
        api_key: this.me.integrations.scrapfly.settings.api_key,
        quote: this.me.integrations.scrapfly.settings.quote,
        chat: this.me.integrations.scrapfly.settings.chat,
        claimed: this.me.integrations.scrapfly.settings.claimed,
        posts: this.me.integrations.scrapfly.settings.posts,
        screenshots: this.me.integrations.scrapfly.settings.screenshots
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingScrapfly = false
        this.me.integrations.scrapfly.status = response.data.integration.status;

        if (response.data.integration.status == 0)
          this.errorScrapfly = "Your Scrapfly key is invalid."
      }
      else {
        this.errorScrapfly = response.data.error
      }

      this.savingScrapfly = false
    },

    async getTwilioNumbers() {

      this.gettingTwilioNumbers = true

      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/agency/get-twilio-numbers`, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.gettingTwilioNumbers = false
        this.me.integrations.twilio.settings.numbers = response.data.integration.settings.numbers;
        this.me.integrations.twilio.settings.phone_number = response.data.integration.settings.phone_number;
      }

      this.gettingTwilioNumbers = false

    },

    async onUpload() {
      // console.log(this.file);
      if (this.file !== null) {
        this.uploading = true
        let formData = new FormData()
        formData.append("file", this.file)

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-logo`, {
            logo: response.data.url
          }, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          this.me.logo = response.data.url
          this.$agency.logo = response.data.url

        }catch(e){
          console.log(e)
        }

        this.file = null
        this.uploading = false
      }
    },

    async onUploadFavicon() {
      // console.log(this.file);
      if (this.file_favicon !== null) {
        this.uploading_favicon = true
        let formData = new FormData()
        formData.append("file", this.file_favicon)

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-favicon`, {
            favicon: response.data.url
          }, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          this.$agency.settings.favicon = response.data.url

          const favicon = document.getElementById("Lead FinderFavicon");
          favicon.href = this.$agency.settings.favicon;

        }catch(e){
          console.log(e)
        }

        this.file_favicon = null
        this.uploading_favicon = false
      }
    },

    async saveSMTPSettings() {

      this.savingSMTP = true
      this.errorSMTP = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-smtp-settings`, {
        from_name: this.me.integrations.smtp.settings.from_name,
        from_email: this.me.integrations.smtp.settings.from_email,
        host: this.me.integrations.smtp.settings.host,
        port: this.me.integrations.smtp.settings.port,
        username: this.me.integrations.smtp.settings.username,
        password: this.me.integrations.smtp.settings.password,
        ssl_tls: this.me.integrations.smtp.settings.ssl_tls
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingSMTP = false
        this.me.integrations.smtp = response.data.integration;

        if (response.data.integration.status == 0)
          this.errorSMTP = "Your SMTP settings are invalid."
      }
      else {
        this.errorSMTP = response.data.error
      }

      this.savingSMTP = false

    },

    getExternalContactFormLink() {
        let url = process.env.VUE_APP_API_ENDPOINT + "/contacts/add-contact-externally"
        return url;
    },

    getExternalContactFormLinkWhiteLabeled() {
        let url = window.location.origin + "/api/contacts/add-contact-externally"
        return url;
    },

    async removeLogo() {
       await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/remove-logo`, {}, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      let self = this
      setTimeout(function() {
        window.location = window.location.href
      }, 200);
    },

    async removeFavicon() {
       await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/remove-favicon`, {}, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      let self = this
      setTimeout(function() {
        window.location = window.location.href
      }, 200);
    },

    formatDate(date) {
      return moment(date).format("MMM D, YYYY")
    },
    copyToClipboard() {
    const textarea = document.getElementById("customMenuLink");
      textarea.select();
      document.execCommand("copy");
      this.$swal({
        title: "Copied!",
        text: "Your custom menu link has been copied to clipboard.",
        icon: "success",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK"
      });
    }
  },
  computed: {
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.me,
      agency: state => state.agency
    }),
    apiEndpointIframe() {
      return `${process.env.VUE_APP_MAIN_URL}/finder/${this.profile.uuid || ''}/{{location.id}}/`;
    }
  },
  mounted() {
    let self = this
    setTimeout(function() {
      if (self.me.domain && (self.me.domain_status == 0 || self.me.ssl_status == 0)) {
        self.saveDomain();
      }

      if (self.me.integrations.twilio.settings.account_sid && self.me.integrations.twilio.status == 0)
        self.errorTwilio = "Your Twilio credentials are invalid."

      if (self.me.integrations.smtp.settings.host && self.me.integrations.smtp.status == 0)
        self.errorSMTP = "Your SMTP settings are invalid."

    }, 1000)

    if (typeof(self.$agency) == "undefined" || self.$agency == null) {
      self.$agency = self.me
    }
  },
  created() {
    this.$store.dispatch('me/fetch')
  }
}
</script>

<style>
.setting-header {
  background-color: #fbfbfb;
}
.setting-body {
  background-color: #fdfdfd;
}

input, textarea {
  border-style: solid;
}

.token_password_toggle {
  position: absolute;
  margin-top: -30px;
  right: 20px;
}

.settings-wrapper fieldset {
    border: 1px solid rgba(25, 35, 58, 0.3) !important;
}
</style>

